<template>
  <div class="resetPwd">
    <app-header head-title="找回密码"></app-header>
    <div class="resetPwdPart">
      <div class="banner">
        <div class="title-tips">
          <div class="title-line"></div>
        </div>
        <div class="center">
          <div class="progressBar">
            <div class="progressBarBg" ref="progressBarBg">
              <span class="step-1" :class="{active: step1}">确认账号</span>
              <span class="step-2" :class="{active: step2}">安全验证</span>
              <span class="step-3" :class="{active: step3}">重置密码</span>
              <span class="step-4" :class="{active: step4}">完成</span>
            </div>
          </div>
          <div class="resetPwdDiv" :class="{step2Div:step2} ">
            <el-form
              ref="resetPwdForm"
              :model="resetPwdForm"
              :rules="resetPwdRules"
              autocomplete="on"
            >
            <div class="error-code" v-if="captchaError">{{ captchaError }}</div>
              <el-form-item style="margin-bottom:20px"
                prop="account"
                v-show="step1 && !step2 && !step3 && !step4"
                :error="accountErrorMsg"
              >
                <el-input
                  ref="account"
                  v-model.trim="resetPwdForm.account"
                  placeholder="请输入手机号或邮箱账号"
                  name="account"
                  id="username"
                  autocomplete="on"
                  @focus="accountErrorMsg=''; captchaError=''"
                />
              </el-form-item>





              <!-- <el-form-item
                class="imgCodeDiv"
                prop="captcha"
                v-show="step1 && !step2 && !step3 && !step4"
                :error="captchaErrorMsg"
              > -->
                  <!-- v-model.trim="resetPwdForm.captcha" -->
                <!-- <el-input
                  style="width: 200px;"
                  ref="captcha"
                  placeholder="请输入图形码"
                  name="captcha"
                  maxLength="6"
                  id="usercaptcha"
                  @focus="captchaErrorMsg=''"
                  :value="resetPwdForm.captcha"
                  @input="e => resetPwdForm.captcha = validSe(e)"
                /> -->
                <!-- <img
                  ref="imgCode"
                  :src="varHost + 'uc/auth/password/forgot/captcha'"
                  @click="imgCodeRefresh()"
                  class="code-img"
                  alt="验证码"
                />
              </el-form-item> -->
              








              <div class="step2-div" v-show="step1 && step2 && !step3 && !step4">
                <div class="step2-tips">
                  <p>为了保证账号安全，需要验证{{accountType}}有效性</p>
                  <p class="phoneNum">{{resetPwdForm.account | hiddenPhoneNum}}</p>
                </div>
                <el-form-item class="code" prop="code" :error="codeErrorMsg">
                  <el-input
                    ref="code"
                    v-model.trim="resetPwdForm.code"
                    placeholder="请输入验证码"
                    @keyup.enter.native="handleResetPwd"
                    @focus="codeErrorMsg=''"
                    type="tel"
                    maxlength="6"
                  />
                </el-form-item>
                <el-button
                  class="codeBtn"
                  :class="{'is-timing':able}"
                  :disabled="able"
                  type="primary"
                  @click="getCode"
                >
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show">{{count}} s</span>
                </el-button>
              </div>
              <div class="step3-div" v-show="step1 && step2 && step3 && !step4">
                <el-form-item prop="password" style="margin-bottom:48px">
                  <el-input
                    ref="password"
                    v-model.trim="resetPwdForm.password"
                    placeholder="请输入新密码"
                    name="password"
                    autocomplete="on"
                    :type="pwdSee?'text':'password'"
                  />
                  <i class="input-icon" :class="{hidden:pwdSee}" @click="showPwd('password')"></i>
                </el-form-item>
                <el-form-item prop="surePassword" style="margin-bottom:39px">
                  <el-input
                    ref="surePassword"
                    v-model.trim="resetPwdForm.surePassword"
                    placeholder="请输入新密码"
                    name="surePassword"
                    autocomplete="off"
                    :type="surePwdSee?'text':'password'"
                  />
                  <i
                    class="input-icon"
                    :class="{hidden:surePwdSee}"
                    @click="showPwd('surePassword')"
                  ></i>
                </el-form-item>
              </div>
              <div class="step4-div" v-show="step1 && step2 && step3 && step4">
                <div class="step4-Bg"></div>
                <p style="font-size:20px">已重置完成</p>
                <p style="font-size:14px;color:#ccc">
                  <span class="5sBack">{{timeOut}}s后返回</span>
                </p>
              </div>
            </el-form>
            <el-button
              :loading="loading"
              class="resetPwdBtn"
              type="primary"
              @click.native.prevent="handleResetPwd"
              v-show="!(step1 && step2 && step3 && step4)"
            >{{btnTips}}</el-button>

            <div class="backToLogin" v-show="step1 && !step2 && !step3 && !step4">
              记得密码，
              <span class="toLogin" @click="toLogin">点击登录</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<style scoped>
.resetPwd .el-button.codeBtn {
  float: right;
  height: 42px;
  margin-top: -81px;
  z-index: 100;
  position: relative;
  padding: 12px 14px;
  background-color: #4981f2;
  color: #fff;
  border-radius: 6px;
  width: 100px;
}
</style>
<script>
import user from "@/api/user";
import header from "@/components/common/header";
import footer from "@/components/common/footer";

export default {
  name: "Regist",
  components: {
    "app-header": header,
    "app-footer": footer
  },
  data() {
    const validateAccount = (rule, value, callback) => {
      if (
        /^1[3456789]\d{9}$/.test(value) ||
        /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(
          value
        )
      ) {
        if (
          /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(
            value
          )
        ) {
          this.accountType = "邮箱";
        }
        callback();
      } else {
        callback(new Error("请输入手机号或邮箱号"));
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入短信验证码"));
      } else {
        callback();
      }
    };
    const validateCaptcha = (rule, value, callback) => {  
      if (value.length != 6) {
        callback(new Error("请输入正确的图形码"));
      } else {
        callback();
      }
    };

    var validatePassword = (rule, value, callback) => {
      var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\S]{8,16}$/;
      if (value.length < 8 || value.length > 16) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else if (!reg.test(value)) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else {
        if (
          this.resetPwdForm.password !== this.resetPwdForm.surePassword &&
          this.resetPwdForm.surePassword != ""
        ) {
          callback(new Error("两次密码输入不同"));
        } else {
          callback();
        }
      }
    };
    var validateSureword = (rule, value, callback) => {
      var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\S]{8,16}$/;
      if (value.length < 8 || value.length > 16) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else if (!reg.test(value)) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else {
        if (this.resetPwdForm.password !== this.resetPwdForm.surePassword) {
          callback(new Error("两次密码输入不同"));
        } else {
          callback();
        }
      }
    };
    return {
      step1: true,
      step2: false,
      step3: false,
      step4: false,
      btnTips: "下一步",
      accountType: "手机",
      timeOut: 5,
      captchaError: "",
      accountErrorMsg: "",
      captchaErrorMsg: "",
      codeErrorMsg: "",
      resetPwdForm: {
        account: "",
        captcha: "",
        code: "",
        password: "",
        surePassword: "",
        ticket: "",
        randstr: ""
      },
      resetPwdRules: {
        account: [
          {
            required: true,
            // message: "请输入手机号或邮箱号",
            trigger: "blur",
            validator: validateAccount
          }
        ],
        captcha: [
          {
            required: true,
            // message: "请输入图形码",
            trigger: "blur",
            validator: validateCaptcha
          }
        ],

        code: [
          {
            required: true,
            // message: "请输入验证码",
            trigger: "blur",
            validator: validateCode
          }
        ],
        password: [
          {
            required: true,
            // message: "请输入新密码",
            trigger: "blur",
            validator: validatePassword
          }
        ],
        surePassword: [
          {
            required: true,
            // message: "请再次输入新密码",
            trigger: "blur",
            validator: validatePassword
          }
        ]
      },
      loading: false,
      pwdSee: false,
      surePwdSee: false,
      show: true,
      count: "",
      timer: null,
      able: false,
      CaptchaAppId: '192261687',
    };
  },
  watch: {
    $route: {}
  },
  computed: {
    // counts() {
    //   console.log(this.$store.state.user.token);
    // }
  },
  created() {
  },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#f3f2f0");
  },
  beforeDestroy() {
    // document.querySelector("body").removeAttribute("style");
  },
  methods: {
    validSe(value){
      value = value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, "").replace(/[\u4e00-\u9fa5]/g,'');
      return value;
    },
    getCode(cb) {
      // 发送请求获取验证码
      user
        .getMsgForgot(this.resetPwdForm.account)
        .then(response => {
          // console.log(777,response);
          this.able = true;
          // 倒计时
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                this.able = false;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
          cb(this);
        })
        .catch(error => {
          // console.log(888,error);
          this.errorMsgEmpty();
          this.$nextTick(function() {
            typeof error == "string" ? (this.accountErrorMsg = error) : true;
          });
        });
    },
    showPwd(which) {
      which == "password"
        ? (this.pwdSee = !this.pwdSee)
        : (this.surePwdSee = !this.surePwdSee);
      this.$nextTick(() => {
        this.$refs[which].focus();
      });
    },
    toLogin() {
      this.$router.push({ path: "/login" });
    },
    errorMsgEmpty() {
      this.captchaError = "";
      this.accountErrorMsg = "";
      this.codeErrorMsg = "";
      this.captchaErrorMsg = "";
    },


    // imgCodeRefresh() {
    //   this.$refs.imgCode.src =
    //     // this.varHost + "uc/auth/password/forgot/captcha?" + Math.random();
    //     this.varHost + "uc/auth/password/forgot/captcha?" + Math.random();
    // },
    getTcaptcha() {
      let _this = this;
      try {
        // 生成一个验证码对象
        let captcha = new TencentCaptcha(this.CaptchaAppId, _this.callback, {});
        // 调用方法，显示验证码
        captcha.show();
      } catch (error) {
        // 加载异常，调用验证码js加载错误处理函数
        this.loadErrorCallback();
      }
    },
    callback(res) {
      // console.log('callback:', res);
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      // res（请求验证码发生错误，验证码自动返回terror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
      if (res.ret === 0) {
        // 验证成功
          this.resetPwdForm.ticket = res.ticket;
          this.resetPwdForm.randstr = res.randstr;
          this.checkCaptchaNewPrev();
      }else if(res.ret === 2){
        this.resetPwdForm.ticket = '';
        this.resetPwdForm.randstr = '';
      }
    },
    loadErrorCallback() {
        let appid = this.CaptchaAppId;
        // 生成容灾票据或自行做其它处理
        let ticket = 'terror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
        this.callback({
          ret: -1,
          randstr: '@' + Math.random().toString(36).substr(2),
          ticket: ticket,
          errorCode: 1001,
          errorMessage: 'jsload_error'
        });
    },
    checkCaptchaNewPrev() {
      user
        .checkCaptchaNew({
          account: this.resetPwdForm.account,
          // captcha: this.resetPwdForm.captcha,
          step: 'confirm-account',
          captcha_result: {
            ticket: this.resetPwdForm.ticket,
            randstr: this.resetPwdForm.randstr
          }
        })
        .then(result => {

          this.step2 = true;
          this.$refs["progressBarBg"].style.backgroundPosition = "-19px -218px";

          this.able = true;
          // 倒计时
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                this.able = false;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
          // this.$Message.success(result.data.message);
          //   this.loading = true;
          // this.getCode(function(this_) {
          // });
        })
        .catch(error => {
          // console.log(4,error);

          // this.imgCodeRefresh()
          this.errorMsgEmpty();
          // this.$Message.error(error);

          this.$nextTick(function() {
            // let errorInfo
            // let flag

            if(error){
              if(error == '验证码验证失败'){
                this.captchaError = error
              } else if(error === "手机号不存在" || error === "手机号格式不正确" || error === "邮箱不存在"){
                // errorInfo = error
                this.accountErrorMsg = error
              }else if(error === "图形验证码错误"){
                // errorInfo = error
                // flag = 1
                this.captchaErrorMsg = error
              }
              // if(flag){
              //   this.captchaErrorMsg = errorInfo
              // }else{
              //   this.accountErrorMsg = errorInfo
              // }
            }
          });
        });
    },
    handleResetPwd() {
      if (!this.step2) {
        this.$refs["resetPwdForm"].validateField("account", error => {

          if (!error) {
            // this.$refs["resetPwdForm"].validateField("captcha", error1 => {
              // console.log(111,error,error1)
              // if (!error1) {
                this.getTcaptcha();

                // user
                // .checkCaptchaNew({
                //   account: this.resetPwdForm.account,
                //   // captcha: this.resetPwdForm.captcha,
                //   step: 'confirm-account'
                // })
                // .then(result => {

                //   this.step2 = true;
                //   this.$refs["progressBarBg"].style.backgroundPosition = "-19px -218px";

                //   this.able = true;
                //   // 倒计时
                //   const TIME_COUNT = 60;
                //   if (!this.timer) {
                //     this.count = TIME_COUNT;
                //     this.show = false;
                //     this.timer = setInterval(() => {
                //       if (this.count > 0 && this.count <= TIME_COUNT) {
                //         this.count--;
                //       } else {
                //         this.show = true;
                //         this.able = false;
                //         clearInterval(this.timer);
                //         this.timer = null;
                //       }
                //     }, 1000);
                //   }
                //   // this.$Message.success(result.data.message);
                //   //   this.loading = true;
                //   // this.getCode(function(this_) {
                //   // });
                // })
                // .catch(error => {
                //   // console.log(4,error);

                //   this.imgCodeRefresh()
                //   this.errorMsgEmpty();
                //   // this.$Message.error(error);

                //   this.$nextTick(function() {
                //     let errorInfo
                //     let flag

                //     if(error){
                //       if(error === "手机号不存在" || error === "手机号格式不正确" || error === "邮箱不存在"){
                //         errorInfo = error
                //       }else if(error === "图形验证码错误"){
                //         errorInfo = error
                //         flag = 1
                //       }
                //       if(flag){
                //         this.captchaErrorMsg = errorInfo
                //       }else{
                //         this.accountErrorMsg = errorInfo
                //       }
                //     }
                //   });
                // });
              // } else {
              //   return false;
              // }
            // });
            
          } else {
            return false;
          }
        });
      } else if (!this.step3 && this.step2) {
        this.$refs["resetPwdForm"].validateField("code", error => {
          if (!error) {
            //   this.loading = true;
            user
              .forgotPwdCheck({
                account: this.resetPwdForm.account,
                account_verify_code: this.resetPwdForm.code
              })
              .then(result => {
                // this.$Message.success(result.data.message);
                this.step3 = true;
                this.btnTips = "重置密码";
                this.$refs["progressBarBg"].style.backgroundPosition =
                  "-19px -256px";
              })
              .catch(error => {
                // console.log(999,error);
                this.errorMsgEmpty();
                this.$nextTick(function() {
                  typeof error == "string" ? (this.codeErrorMsg = error) : true;
                });
              });
          } else {
            return false;
          }
        });
      } else if (!this.step4 && this.step3) {
        this.$refs["resetPwdForm"].validateField("password", error => {
          if (!error) {
          } else {
            return false;
          }
        });
        this.$refs["resetPwdForm"].validateField("surePassword", error => {
          if (!error) {
            this.loading = true;
            user
              .forgotPwd({
                account: this.resetPwdForm.account,
                password: this.resetPwdForm.password,
                password_confirmation: this.resetPwdForm.surePassword
              })
              .then(result => {
                // console.log(result);
                this.loading = false;
                // this.$Message.success(result.data.message);
                this.step4 = true;
                this.$refs["progressBarBg"].style.backgroundPosition =
                  "-19px -293px";
                var clear = setInterval(() => {
                  this.timeOut--;
                }, 1000);
                setTimeout(() => {
                  clearInterval(clear);
                  this.toLogin();
                }, 5000);
              })
              .catch(err => {
                // console.log(err);
              });
          } else {
            return false;
          }
        });
      }
    }
  }
};
</script>

<style lang="scss">
/* reset element-ui css */
.resetPwd {
  .el-input {
    display: inline-block;
    height: 42px;

    input {
      border: 0px;
      -webkit-appearance: none;
      border-radius: 6px;
      padding: 12px 5px 12px 15px;
      height: 42px;
      line-height: 40px;
    }
  }

  .el-form-item {
    background: #fff;
    border-radius: 6px;
    color: #454545;
    .input-icon {
      width: 16px;
      height: 10px;
      background: url("../../assets/images/icons.png") no-repeat -78px -22px;
      display: inline-block;
      position: absolute;
      right: 15px;
      top: 16px;
      cursor: pointer;
    }
    .input-icon.hidden {
      background: url("../../assets/images/icons.png") no-repeat -105px -22px;
    }
    .el-form-item__content {
      line-height: 42px;
      height: 42px;
    }
  }

  .el-form-item.code {
    width: 210px;
    margin-top: 22px;
    margin-bottom: 38px;
  }
}
</style>

<style lang="scss" scoped>
.resetPwd {
  background-color: #f3f2f0;
  width: 100%;
  overflow: hidden;
  .imgCodeDiv{
    background: none;
  }
  .code-img{
    position: absolute;
    right: 0;
    width: 110px;
    height: 42px;
  }
  .resetPwdPart {
    height: 720px;
    background: url(../../assets/images/RegisterBG.png) repeat-x top;
    position: relative;
    .title-tips {
      position: absolute;
      top: 90px;
      left: 50%;
      z-index: 101;
      margin-left: -110px;
      width: 220px;
      height: 50px;
      background: url(../../assets/images/icons.png) no-repeat -20px -354px;
      .title-line {
        position: absolute;
        bottom: -14px;
        left: 50%;
        z-index: 101;
        margin-left: -100px;
        width: 200px;
        height: 3px;
        background: url(../../assets/images/icons.png) no-repeat -40px -240px;
      }
    }
    .center {
      height: 720px;
      position: relative;
      width: 1000px;
      margin: 0 auto;
      .progressBar {
        height: 28px;
        width: 480px;
        background: #fff;
        position: absolute;
        top: 180px;
        left: 50%;
        margin-left: -240px;
        border-radius: 15px;
        overflow: hidden;
        .progressBarBg {
          height: 28px;
          width: 480px;
          background: url("../../assets/images/icons.png") -19px -180px;

          // background: url("../../assets/images/icons.png") -19px -218px;
          // background: url("../../assets/images/icons.png") -19px -256px;
          // background: url("../../assets/images/icons.png") 19px -293px;
          position: absolute;
          left: 0;
        }
        span {
          width: 120px;
          height: 28px;
          color: #ccc;
          line-height: 28px;
          float: left;
          text-align: center;
          font-style: italic;
        }
        span.active {
          color: #fff;
        }
      }
    }
    .resetPwdDiv {
      width: 320px;
      margin: 0 auto;
      position: absolute;
      top: 274px;
      left: 50%;
      margin-left: -160px;
      .step2-div {
        .step2-tips {
          p {
            color: #ccc;
            font-size: 14px;
            text-align: center;
            margin: 10px 0;
          }
          .phoneNum {
            color: #000;
            font-size: 18px;
          }
        }
      }
      .step3-div {
        margin-top: 37px;
      }
      .step4-div {
        margin-top: 37px;
        .step4-Bg {
          height: 170px;
          background: url("../../assets/images/icon-3a.png") no-repeat top;
          margin-bottom: 11px;
        }
        p {
          text-align: center;
          margin-bottom: 4px;
        }
      }
    }
    .resetPwdDiv.step2Div {
      top: 242px;
    }
  }

  .resetPwd-form {
    position: relative;
    max-width: 100%;
    padding-top: 200px;
    margin: 0 auto;
    overflow: hidden;
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 0;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
  }
  .resetPwdBtn {
    width: 100%;
    height: 46px;
    margin-bottom: 24px;
    background: #4981f2;
    color: #fff;
    border-radius: 6px;
    margin-top: 20px;
  }
  .backToLogin {
    font-size: 12px;
    text-align: center;
    .toLogin {
      color: #4981f2;
      cursor: pointer;
    }
  }
  .error-code {
    font-size: 12px;
    position: absolute;
    top: 45px;
    z-index: 100;
    color: #f00;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resetPwd/index.vue